import React from 'react';
const FormSVG = ({ color = 'black', className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      className={className}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.625 16.875V1.125H7.3125C7.62356 1.125 7.875 0.873 7.875 0.5625C7.875 0.252 7.62356 0 7.3125 0H2.8125C2.50144 0 2.25 0.252 2.25 0.5625C2.25 0.873 2.50144 1.125 2.8125 1.125H4.5V16.875H2.8125C2.50144 16.875 2.25 17.127 2.25 17.4375C2.25 17.748 2.50144 18 2.8125 18H7.3125C7.62356 18 7.875 17.748 7.875 17.4375C7.875 17.127 7.62356 16.875 7.3125 16.875H5.625ZM2.8125 2.25C3.12356 2.25 3.375 2.502 3.375 2.8125C3.375 3.123 3.12356 3.375 2.8125 3.375H1.125V14.625H2.8125C3.12356 14.625 3.375 14.877 3.375 15.1875C3.375 15.498 3.12356 15.75 2.8125 15.75H1.125C0.504 15.75 0 15.246 0 14.625V3.375C0 2.754 0.504 2.25 1.125 2.25H2.8125ZM18 3.375C18 2.754 17.496 2.25 16.875 2.25H7.3125C7.00144 2.25 6.75 2.502 6.75 2.8125C6.75 3.123 7.00144 3.375 7.3125 3.375H16.875V14.625H7.3125C7.00144 14.625 6.75 14.877 6.75 15.1875C6.75 15.498 7.00144 15.75 7.3125 15.75H16.875C17.496 15.75 18 15.246 18 14.625V3.375Z"
        fill={color}
      />
    </svg>
  );
};

export default FormSVG;
